


export const SHORT_TASK_QUESTIONS_3 = [
    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>「晴蓉剛上課時，看見自己課本上黏 了張便條紙，內容提及她最近剛好 想去體驗的實境遊戲題材，她好想答應邀約，可是便條紙內容卻不夠清楚，讓她無法做出決定。<br/><img src="/secondary/tasks/tt1.png" alt="便條紙">',
        question: '請問便條紙中只清楚呈現出哪一個訊息？',
        options: [
            { text: 'A. 預計體驗的日期', },
            { text: 'B. 預計體驗的時間', },
            { text: 'C. 預計體驗的遊戲', },
            { text: 'D. 預計邀約的人數', },
        ],
        background: '#F8FAFB',
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「對我而言，哲學課的目標在於能達到讓學生去反思問題，甚至打破既有的想法，能開始質疑他過去所接受的觀點或訊息。」',
        question: '這句話的涵義，與下列何者最接近？',
        options: [
            { text: 'A. 哲學的目的是為了否定過去所學。', },
            { text: 'B. 學習哲學是為了不斷對話及提問。', },
            { text: 'C. 哲學的訓練是為了打破既有框架。', },
            { text: 'D. 反思問題是哲學課程的唯一途徑。', },
        ],
        
         backgroundImage: '/secondary/tasks/rp2.png'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>「□□□不只引領人類找出解決技術與科技問題的革新辦法，同時也為我們展開了各種可能性，改善真實生活中的惱人困擾。□□□並不是清晰判斷力的敵人，反而是理性的夥伴，它為現實帶來嶄新的光芒與靈性願景，這些正是我們消費至上的社會所欠缺的。」',
        question: '根據文意脈絡，□□□最可能是下列哪一項基本能力？',
        options: [
            { text: 'A. 想像力' },
            { text: 'B. 記憶力' },
            { text: 'C. 感受力' },
            { text: 'D. 觀察力' },
        ],
        background: '#F8FAFB',
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「那片靜謐的湖泊位在山坳處。據導遊說，是為了紀念古老的傳說，才取了如此夢幻空靈的名字。更重要的是，湖水澄澈。這年我十歲，湖面平靜得像是一面巨大的明鏡。記憶裏我從未見過湖底的淤泥，湖水不是輕撫著岸邊的鵝卵石，就是溫柔地映照著連綿的雲朵，要不就綢緞般地滑過石縫，甚美。在我眼裏，它簡直是一座宮殿。多年後，我在畫廊看到這張油畫，那時，這座湖已乾涸十年了。」 ',
        question: '依照上文內容，下列文句，何者屬於「客觀性」的敘述？',
        options: [
            { text: 'A. 湖水不是輕撫著岸邊的鵝卵石，就是溫柔地映照著連綿的雲朵。' },
            { text: 'B. 記憶裡我從未見過湖底的淤泥，湖水綢緞般地滑過石縫，甚美。' },
            { text: 'C. 那片靜謐的湖泊位在山坳處，湖面平靜得像是一面巨大的明鏡。' },
            { text: 'D. 多年後，我在畫廊看到這張油畫，那時，這座湖已乾涸十年了。' }
        ],
        
         backgroundImage: '/secondary/tasks/rp3.png'
    }
]